import { useMemo } from "react";

import { Card, Container } from "@mui/material";
import RffDynamicForm from "../components/finalForm/RffDynamicForm";
import Screen from "../components/layout/Screen";
import ScreenContent from "../components/layout/ScreenContent";
import Htag from "../components/typography/Htag";
import LendmarqChecklistTable from "../components/common/LendmarqChecklistTable";

const DynamicFormScreen = () => {
  const onFormSubmit = (data) => {
    alert("Check console for form data");
    console.log("Dynamic Form Submitted: ", data);
  };

  const initialValues = useMemo(() => {
    return {
      // entityAddress: {
      //   street: "street",
      //   city: "city",
      //   state: "state",
      //   postalCode: "postalCode",
      //   fullAddress: "fullAddress",
      // },
    };
  }, []);

  const dynamicFields = useMemo(() => {
    return [...exampleFullObject?.root?.form, ...propertySchema];
  }, []);

  return (
    <Screen>
      <ScreenContent>
        {/* <Container maxWidth="lg">
          <LendmarqChecklistTable />
        </Container> */}
        <Container maxWidth="md">
          <Htag sx={{ mt: 2 }}>Dynamic Form</Htag>
          <Card sx={{ p: 3, mt: 2 }}>
            <RffDynamicForm
              loading={false}
              formSpy
              initialValues={initialValues}
              onSubmit={onFormSubmit}
              fields={dynamicFields}
              prePopulateFieldsEditor
            />
          </Card>
        </Container>
      </ScreenContent>
    </Screen>
  );
};

const exampleFullObject = {
  root: {
    model: "BorrowingEntity",
    form: [
      {
        name: "entityName",
        label: "Entity Name",
        description: "the name of the entity",
        required: false,
        default: null,
        form_type: "text",
        ag_grid_col_type: "text",
        is_object_id: false,
        options: null,
        display_column: true,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "entityAddress",
        label: "Entity Address",
        description: null,
        required: false,
        default: null,
        form_type: "object",
        ag_grid_col_type: "string",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "object",
        nested_models: ["Address"],
        nested_value: "fullAddress",
        hide: false,
        annotation_type: "Address | NoneType",
        nullable: true,
        default_present: true,
        nested_model: "Address",
        nested_model_schema: [
          {
            name: "street",
            label: "Street",
            description: "Street",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "string",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "city",
            label: "City",
            description: "City",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "string",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "state",
            label: "State",
            description: "State",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "string",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "postalCode",
            label: "Postal Code",
            description: "ZIP",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "string",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "fullAddress",
            label: "Full Address",
            description: "Computed display address",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "string",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
        ],
      },
      {
        name: "entityType",
        label: "Entity Type",
        description: "the type of entity",
        required: false,
        default: null,
        form_type: "select",
        ag_grid_col_type: "text",
        is_object_id: false,
        options: [
          "LLC",
          "S-Corp",
          "Revocable Trust",
          "Irrecovable Trust",
          "TBD",
        ],
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "entityOrganizationDate",
        label: "Entity Organization Date",
        description:
          "the date the entity was created or organized. Original creation of the entity",
        required: false,
        default: null,
        form_type: "date",
        ag_grid_col_type: "date",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "datetime | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "entityOrganizationDate",
        label: "Entity Organization Date",
        description:
          "the date the entity was created or organized. Original creation of the entity",
        required: false,
        default: null,
        form_type: "date",
        ag_grid_col_type: "date",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "datetime | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "entityMembers",
        label: "Entity Members",
        description: null,
        required: false,
        default: [],
        form_type: "object",
        ag_grid_col_type: "array",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "object",
        nested_models: ["EntityMember"],
        nested_value: null,
        hide: false,
        annotation_type: "List[EntityMember] | NoneType",
        nullable: true,
        default_present: true,
        nested_model: "EntityMember",
        nested_model_schema: [
          {
            name: "fullName",
            label: "Full Name",
            description: "the full name of the entity member or manager",
            required: false,
            default: null,
            form_type: "text",
            ag_grid_col_type: "text",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "entityPercentOwnership",
            label: "Entity Percent Ownership",
            description: "the percent ownership of the entity",
            required: false,
            default: 0,
            form_type: "percent",
            ag_grid_col_type: "percent",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "float | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "isGuarantor",
            label: "Is Guarantor",
            description: "is the borrower a guarantor on the loan?",
            required: false,
            default: false,
            form_type: "booleanToggle",
            ag_grid_col_type: "boolean",
            is_object_id: false,
            options: null,
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "bool | NoneType",
            nullable: true,
            default_present: true,
          },
          {
            name: "entityRole",
            label: "Entity Role",
            description: "the role of the entity member",
            required: false,
            default: null,
            form_type: "select",
            ag_grid_col_type: "text",
            is_object_id: false,
            options: ["Manager", "Member", "Officer", "Other"],
            display_column: false,
            kind: "scalar",
            nested_models: [],
            nested_value: null,
            hide: false,
            annotation_type: "str | NoneType",
            nullable: true,
            default_present: true,
          },
        ],
      },
      {
        name: "entityNotes",
        label: "Entity Notes",
        description: null,
        required: false,
        default: null,
        form_type: "stringMultiline",
        ag_grid_col_type: "stringMultiline",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | NoneType",
        nullable: true,
        default_present: true,
        // Example 1
        docGroup: "Liquidity",
        docType: "Bank Statement",
        // Example 2
        uploadFileParms: {
          docGroup: "Liquidity",
          docType: "Bank Statement",
        },
      },
      {
        name: "entityNotes",
        label: "Entity Notes",
        description: null,
        required: false,
        default: null,
        form_type: "stringMultiline",
        ag_grid_col_type: "stringMultiline",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | NoneType",
        nullable: true,
        default_present: true,
        docGroup: "Liquidity",
      },
      {
        name: "entityEINNumber",
        label: "Entity Einnumber",
        description: null,
        required: false,
        default: null,
        form_type: "text",
        ag_grid_col_type: "text",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | int | NoneType",
        nullable: true,
        default_present: true,
      },

      {
        name: "entityGoodstandingDate",
        label: "Entity Goodstanding Date",
        description:
          "the date of the certificate of good standing if required (entity > 30 days since inception)",
        required: false,
        default: null,
        form_type: "date",
        ag_grid_col_type: "date",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "datetime | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "salesforceId",
        label: "Salesforce Id",
        description:
          "the Salesforce Account ID for this entity, used for mapping to Salesforce records",
        required: false,
        default: null,
        form_type: "default",
        ag_grid_col_type: "string",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "str | NoneType",
        nullable: true,
        default_present: true,
      },
      {
        name: "last_integration_sync",
        label: "Last Integration Sync",
        description:
          "the last time the entity was synced with an external system like Salesforce or Hubspot",
        required: false,
        default: null,
        form_type: "default",
        ag_grid_col_type: "string",
        is_object_id: false,
        options: null,
        display_column: false,
        kind: "scalar",
        nested_models: [],
        nested_value: null,
        hide: false,
        annotation_type: "datetime | NoneType",
        nullable: true,
        default_present: true,
      },
    ],
    agGrid: {
      columnDefs: [
        {
          name: "entityName",
          headerName: "Entity Name",
          type: "text",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          width: 220,
          hide: false,
        },
        {
          name: "entityAddress",
          headerName: "Entity Address",
          type: "string",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
          valueGetter: {
            usesParams: true,
            body: "value && value.fullAddress",
          },
        },
        {
          name: "entityType",
          headerName: "Entity Type",
          type: "text",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
        },
        {
          name: "entityOrganizationDate",
          headerName: "Entity Organization Date",
          type: "date",
          sortable: true,
          resizable: true,
          filter: "agDateColumnFilter",
          enablePivot: true,
          enableValue: true,
          valueFormatterKey: "date",
          hide: false,
        },
        {
          name: "entityNotes",
          headerName: "Entity Notes",
          type: "stringMultiline",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
        },
        {
          name: "entityEINNumber",
          headerName: "Entity Einnumber",
          type: "text",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
        },
        {
          name: "entityMembers",
          headerName: "Entity Members",
          type: "array",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: true,
        },
        {
          name: "entityGoodstandingDate",
          headerName: "Entity Goodstanding Date",
          type: "date",
          sortable: true,
          resizable: true,
          filter: "agDateColumnFilter",
          enablePivot: true,
          enableValue: true,
          valueFormatterKey: "date",
          hide: false,
        },
        {
          name: "salesforceId",
          headerName: "Salesforce Id",
          type: "string",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
        },
        {
          name: "last_integration_sync",
          headerName: "Last Integration Sync",
          type: "string",
          sortable: true,
          resizable: true,
          filter: "agTextColumnFilter",
          enablePivot: true,
          enableValue: true,
          hide: false,
        },
      ],
    },
  },
  nested_models: {
    Address: {
      form: [
        {
          name: "street",
          label: "Street",
          description: "Street",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "string",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "city",
          label: "City",
          description: "City",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "string",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "state",
          label: "State",
          description: "State",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "string",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "postalCode",
          label: "Postal Code",
          description: "ZIP",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "string",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "fullAddress",
          label: "Full Address",
          description: "Computed display address",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "string",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
      ],
      agGrid: {
        columnDefs: [
          {
            name: "street",
            headerName: "Street",
            type: "string",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "city",
            headerName: "City",
            type: "string",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "state",
            headerName: "State",
            type: "string",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "postalCode",
            headerName: "Postal Code",
            type: "string",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "fullAddress",
            headerName: "Full Address",
            type: "string",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
        ],
      },
    },
    EntityMember: {
      form: [
        {
          name: "fullName",
          label: "Full Name",
          description: "the full name of the entity member or manager",
          required: false,
          default: null,
          form_type: "text",
          ag_grid_col_type: "text",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "entityPercentOwnership",
          label: "Entity Percent Ownership",
          description: "the percent ownership of the entity",
          required: false,
          default: 0,
          form_type: "percent",
          ag_grid_col_type: "percent",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "float | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "isGuarantor",
          label: "Is Guarantor",
          description: "is the borrower a guarantor on the loan?",
          required: false,
          default: false,
          form_type: "booleanToggle",
          ag_grid_col_type: "boolean",
          is_object_id: false,
          options: null,
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "bool | NoneType",
          nullable: true,
          default_present: true,
        },
        {
          name: "entityRole",
          label: "Entity Role",
          description: "the role of the entity member",
          required: false,
          default: null,
          form_type: "select",
          ag_grid_col_type: "text",
          is_object_id: false,
          options: ["Manager", "Member", "Officer", "Other"],
          display_column: false,
          kind: "scalar",
          nested_models: [],
          nested_value: null,
          hide: false,
          annotation_type: "str | NoneType",
          nullable: true,
          default_present: true,
        },
      ],
      agGrid: {
        columnDefs: [
          {
            name: "fullName",
            headerName: "Full Name",
            type: "text",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "entityPercentOwnership",
            headerName: "Entity Percent Ownership",
            type: "percent",
            sortable: true,
            resizable: true,
            filter: "agNumberColumnFilter",
            enablePivot: true,
            enableValue: true,
            aggFunc: "sum",
            valueFormatterKey: "percent",
            width: 140,
            hide: false,
          },
          {
            name: "isGuarantor",
            headerName: "Is Guarantor",
            type: "boolean",
            sortable: true,
            resizable: true,
            filter: true,
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
          {
            name: "entityRole",
            headerName: "Entity Role",
            type: "text",
            sortable: true,
            resizable: true,
            filter: "agTextColumnFilter",
            enablePivot: true,
            enableValue: true,
            hide: false,
          },
        ],
      },
    },
  },
};

const propertySchema = [
  {
    name: "oid",
    label: "Oid",
    description: null,
    required: false,
    default: undefined,
    form_type: "default",
    agGridColType: "string",
    isObjectId: true,
    options: null,
    displayColumn: false,
  },
  {
    name: "dealId",
    label: "Deal Id",
    description: null,
    required: false,
    default: null,
    form_type: "default",
    agGridColType: "string",
    isObjectId: true,
    options: null,
    displayColumn: false,
  },
  {
    name: "propertyType",
    label: "Property Type",
    description: null,
    required: false,
    default: null,
    form_type: "select",
    agGridColType: "text",
    isObjectId: false,
    options: [
      "SFR",
      "2-unit",
      "3-unit",
      "4-unit",
      "5-unit",
      "6-unit",
      "7-unit",
      "8-unit",
      "Condo",
      "Townhome",
      "Planned Unit Development (PUD)",
      "Multifamily",
      "Mixed-Use",
      "Commercial",
      "Undeveloped Land",
      "Other",
      "Non-Warrantable Condo",
    ],
    displayColumn: false,
  },
  {
    name: "proposedPropertyType",
    label: "Proposed Property Type",
    description: null,
    required: false,
    default: null,
    form_type: "select",
    agGridColType: "text",
    isObjectId: false,
    options: [
      "SFR",
      "2-unit",
      "3-unit",
      "4-unit",
      "5-unit",
      "6-unit",
      "7-unit",
      "8-unit",
      "Condo",
      "Townhome",
      "Planned Unit Development (PUD)",
      "Multifamily",
      "Mixed-Use",
      "Commercial",
      "Undeveloped Land",
      "Other",
      "Non-Warrantable Condo",
    ],
    displayColumn: false,
  },
  {
    name: "lastIntegrationSync",
    label: "Last Integration Sync",
    description:
      "the last time the property was synced with an external system like Salesforce or Hubspot",
    required: false,
    default: null,
    form_type: "default",
    agGridColType: "string",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "propertyRuralIndicator",
    label: "Property Rural Indicator",
    description:
      "True if the property in a rural area, otherwise false or blank",
    required: false,
    default: false,
    form_type: "booleanToggle",
    agGridColType: "boolean",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "asIsValue",
    label: "As Is Value",
    description:
      "the as-is value for the property. Populate estimate until appraisal is in, then should reflect the amount in the appraisal",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "arv",
    label: "Arv",
    description:
      "the after reno value for the property. populate estimate until appraisal is in, then should reflect the amount in the appraisal",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "secondaryArv",
    label: "Secondary Arv",
    description:
      "the secondary after reno value for the property as documented in CDA or other secondary appraisal",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "appraisalDate",
    label: "Appraisal Date",
    description:
      "the scheduled date for an appraisal if in the future or the date on the actual appraisal report",
    required: false,
    default: null,
    form_type: "date",
    agGridColType: "date",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "secondaryAppraisalDate",
    label: "Secondary Appraisal Date",
    description:
      "the date on the actual secondary appraisal report. leave blank until received",
    required: false,
    default: null,
    form_type: "date",
    agGridColType: "date",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "purchasePrice",
    label: "Purchase Price",
    description:
      "the purchase price for the property. This should include populating the original purchase price for refis",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "additionalBasis",
    label: "Additional Basis",
    description:
      "the additional $ amount of borrower cost basis for the property. This would include cost of improvements (that can be validated)",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "assignmentFees",
    label: "Assignment Fees",
    description:
      "If there is an assignment of purchase contract for the property, this is the assignment fee in dollars",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "sellersConcession",
    label: "Sellers Concession",
    description:
      "If there is seller concession outlined in purchase contract for the property, this is the concession amount in dollars",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "purchaseDate",
    label: "Purchase Date",
    description:
      "the date of purchase for the property. This should include populating the original purchase date for refis",
    required: false,
    default: null,
    form_type: "date",
    agGridColType: "date",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "propertyListedForSale",
    label: "Property Listed For Sale",
    description:
      "TRUE or FALSE if any of the properties in the loan are currently listed for sale. Important for DSCR loans but helpful for reference on valuation to see if price listed is in line with as-is and when servicing, if currently listed as an indicator of potential payoff",
    required: false,
    default: null,
    form_type: "booleanToggle",
    agGridColType: "boolean",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "lastListedForSaleDate",
    label: "Last Listed For Sale Date",
    description: "the date the property was last listed for sale",
    required: false,
    default: null,
    form_type: "date",
    agGridColType: "date",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "lastListedForSalePrice",
    label: "Last Listed For Sale Price",
    description: "the price the property was last listed for sale",
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "dollar",
    isObjectId: false,
    options: null,
    displayColumn: false,
  },
  {
    name: "costBasis",
    label: "Cost Basis",
    description: null,
    required: false,
    default: null,
    form_type: "dollar",
    agGridColType: "currency",
    readOnly: true,
    computed: true,
  },
  {
    name: "secondaryAsIsVariance",
    label: "Secondary As Is Variance",
    description: null,
    required: false,
    default: null,
    form_type: "percent",
    agGridColType: "percent",
    readOnly: true,
    computed: true,
  },
];

export default DynamicFormScreen;
